var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.data.componentBaseClassName, _vm.data.componentClassName] },
    [
      _vm.regionsHtml.title
        ? _c("div", {
            class: _vm.data.titleClassName,
            domProps: { innerHTML: _vm._s(_vm.regionsHtml.title) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.regionsHtml.poster
        ? _c("div", {
            class: _vm.data.posterClassName,
            domProps: { innerHTML: _vm._s(_vm.regionsHtml.poster) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sliderProducts
        ? _c("BaseProductSlider", {
            class: _vm.data.sliderClassName,
            attrs: {
              products: _vm.sliderProducts,
              "tile-context": _vm.data.sliderLayout,
              "data-component-type": _vm.categoryFeaturedProducts
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }